<template>
  <div class="layout" id="myComponentDiv">
    <div class="box-titulo">Gestión de Clientes</div>
    <div class="box-container">
      <div class="box-filtres">
        <table>
          <tbody>
            <tr>
              <td>
                <button class="btn btn-warning" type="submit" data-id="-1" id="nuevo-clientes">
                  Nuevo
                </button>
              </td>
              <td>
                <button class="btn btn-warning" type="submit" v-on:click="getReporteClientes">
                  Consultar
                </button>
              </td>
              <td>
                <div v-if="loading">
                  <img src="dist/img/kubber-loading.gif" style="width: 30px" />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div id="containter-table" class="containter-table">
        <table id="table1" width="100%">
          <thead>
            <tr>
              <th width="50px">Documento</th>
              <th width="130px">Identificación</th>
              <th>Nombre</th>
              <th>Apellidos</th>
              <th width="80px" class="text-center">Accion</th>
            </tr>
          </thead>
        </table>
      </div>

      <div id="myModal" class="modal" role="dialog">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Formulario</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div class="modal-body">
              <div class="pad10 bg-formulario">
                <form autocomplete="nope">
                  <table width="100%">
                    <tbody>
                      <tr>
                        <td width="50%">
                          <div>
                            <div>TIPO DE DOCUMENTO</div>
                            <select class="form-control" v-model="entidad.tipo">
                              <option :key="item._id" :value="item._id" v-for="item in documentos">
                                {{ item.descripcion }}
                              </option>
                            </select>
                          </div>
                        </td>
                        <td>
                          <div>
                            <div>IDENTIFICACION</div>
                            <input class="form-control" v-model="entidad.identificacion" autocomplete="off" />
                          </div>
                        </td>
                      </tr>

                      <tr v-if="GLOBAL.COUNTRY == 'CO'">
                        <td>
                          <div>
                            <div>NOMBRES</div>
                            <input class="form-control" v-model="entidad.nombres" autocomplete="off" />
                          </div>
                        </td>
                        <td>
                          <div>
                            <div>APELLIDOS</div>
                            <input class="form-control" autocomplete="off" v-model="entidad.apellidos" />
                          </div>
                        </td>
                      </tr>

                      <tr v-if="GLOBAL.COUNTRY == 'MX'">
                        <td colspan="2">
                          <div>
                            <div>NOMBRES O RAZÓN SOCIAL</div>
                            <input class="form-control" v-model="entidad.nombres" autocomplete="off" />
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td colspan="2">
                          <table width="100%">
                            <tbody>
                              <tr>
                                <td>TELÉFONO</td>
                                <td>
                                  <input class="form-control" autocomplete="nope"
                                    v-model="entidad.telefono.descripcion" />
                                </td>
                              </tr>
                              <tr>
                                <td>DIRECCIÓN</td>
                                <td>
                                  <input class="form-control" autocomplete="nope"
                                    v-model="entidad.direccion.descripcion" />
                                </td>
                              </tr>
                              <tr>
                                <td>CORREO</td>
                                <td>
                                  <input class="form-control" autocomplete="nope"
                                    v-model="entidad.correo.descripcion" />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <table width="100%" style="margin-top: 10px">
                    <tbody>
                      <tr>
                        <td width="50%">PAIS</td>
                        <td>
                          <Select2 v-model="opais" :options="paises" @select="selectPais($event)" />
                        </td>
                      </tr>

                      <tr v-if="GLOBAL.COUNTRY == 'MX'">
                        <td>ESTADO</td>
                        <td>
                          <Select2 v-model="oprovincia" :options="provincias" @select="selectProvicias($event)" />
                        </td>
                      </tr>
                      <tr v-if="GLOBAL.COUNTRY == 'CO'">
                        <td>DEPARTAMENTO</td>
                        <td>
                          <Select2 v-model="oprovincia" :options="provincias" @select="selectProvicias($event)" />
                        </td>
                      </tr>
                      <tr v-if="GLOBAL.COUNTRY == 'MX'">
                        <td>MUNICIPIO</td>
                        <td>
                          <Select2 v-model="ociudad" :options="ciudades" @select="selectCiudad($event)" />
                        </td>
                      </tr>
                      <tr v-if="GLOBAL.COUNTRY == 'CO'">
                        <td>CIUDAD</td>
                        <td>
                          <Select2 v-model="ociudad" :options="ciudades" @select="selectCiudad($event)" />
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <table width="100%" style="margin-top: 10px">
                    <tbody>
                      <tr v-if="GLOBAL.COUNTRY == 'MX'">
                        <td width="50%">CODIGO POSTAL</td>
                        <td>
                          <input v-model="codigo_postal" class="form-control" v-on:keypress="GLOBAL.SOLO_NUMEROS"
                            autocomplete="nope" />
                        </td>
                      </tr>
                      <tr v-if="GLOBAL.COUNTRY == 'CO'">
                        <td width="40%" class="factura-label">
                          RESPONSABLE DE IVA
                        </td>
                        <td>
                          <select v-model="responsable_iva" class="form-control">
                            <option selected disabled></option>
                            <option value="S">SI</option>
                            <option value="N">NO</option>
                          </select>
                        </td>
                      </tr>

                      <tr>
                        <td class="factura-label">TIPO RESPONSABILIDAD</td>
                        <td>
                          <select class="form-control" v-model="tipo_responsabilidad">
                            <option v-for="item in lista_responsabilidad" :value="item._id" :key="item._id">
                              {{ item.descripcion }}
                            </option>
                          </select>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <table width="100%" style="margin-top: 10px" v-if="GLOBAL.COUNTRY == 'MX'">
                    <tbody>
                      <tr>
                        <td width="50%" class="factura-label">
                          METODO DE PAGO
                        </td>
                        <td>
                          <select class="form-control" v-model="tipo_metodo_pago">
                            <option v-for="item in lista_metodo_pago" :value="item._id" :key="item._id">
                              {{ item.descripcion }}
                            </option>
                          </select>
                        </td>
                      </tr>

                      <tr>
                        <td class="factura-label">USO CFDI</td>
                        <td>
                          <select class="form-control" v-model="tipo_uso_cfdi">
                            <option v-for="item in lista_uso_cfdi" :value="item._id" :key="item._id">
                              {{ item.descripcion }}
                            </option>
                          </select>
                        </td>
                      </tr>

                      <tr>
                        <td class="factura-label">FORMA DE PAGO</td>
                        <td>
                          <select class="form-control" v-model="tipo_forma_pago">
                            <option v-for="item in lista_forma_pago" :value="item._id" :key="item._id">
                              {{ item.descripcion }}
                            </option>
                          </select>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <div class="card-footer clearfix">
                    <button class="btn btn-success float-right" v-on:click="guardarClientes">
                      Guardar
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="!permiso_lista">
        {{ this.person.nombre }}, {{ this.GLOBAL.MENSAJE.SIN_AUTORIZACION }}
      </div>
    </div>
  </div>
</template>

<script>
import GLOBAL from "../../Global.js";
import ClienteService from "../../service/ClienteService";
import Select2 from "vue3-select2-component";

export default {
  components: { Select2 },
  data() {
    return {
      GLOBAL,
      table: null,
      reporteService: null,
      person: null,
      permiso_lista: false,
      reporte: [],
      entidad: [],
      loading: true,
      tipo: "",
      documentos: [],

      paises: [],
      opais: "",
      pais: [],

      provincias: [],
      oprovincia: "",
      provincia: [],

      ciudades: [],
      ociudad: "",
      ciudad: [],

      codigo_postal: "",
      responsable_iva: "",

      tipo_responsabilidad: "",
      lista_responsabilidad: [],

      tipo_metodo_pago: "",
      lista_metodo_pago: [],

      tipo_uso_cfdi: "",
      lista_uso_cfdi: [],

      tipo_forma_pago: "",
      lista_forma_pago: [],
    };
  },
  created() {
    this.person = JSON.parse(sessionStorage.getItem(GLOBAL.SESSION_KEY));
    this.permiso_lista = this.person.funciones.includes(
      GLOBAL.PERMISOS.REPORTE.HOROMETRO
    );

    this.reporteService = new ClienteService();

    this.reset();
    this.getDocumentos();
    this.getResponsabilidades();
    this.getPaises();
    this.getProvincias(GLOBAL.COUNTRY);
    if (GLOBAL.COUNTRY == "CO") {
      this.getCiudades("", "");
    }
  },
  beforeRouteLeave(to, from, next) {
    $("#table1").DataTable().destroy();
    next();
  },
  mounted() {
    this.table = $("#containter-table").html();

    this.getReporteClientes();

    this.pais = GLOBAL.COUNTRY;
  },
  methods: {
    reset() {
      this.entidad = [];
      this.entidad._id = "";
      this.entidad.persona = [];
      this.entidad.telefono = [];
      this.entidad.telefono.descripcion = "";
      this.entidad.correo = [];
      this.entidad.correo.descripcion = "";
      this.entidad.direccion = [];
      this.entidad.direccion.descripcion = "";

      this.tipo = "";
      this.opais = "";
      this.oprovincia = "";
      this.ociudad = "";
      this.responsable_iva = "";
      this.tipo_responsabilidad = "";
    },

    getDetallesClientes(item) {
      this.entidad = {};
      var object = [];
      if (item !== -1) {
        object = this.reporte[item];
        this.entidad._id = object._id;
        this.entidad.p_uuid = object.p_uuid;
        this.entidad.nombres = object.nombres;
        this.entidad.apellidos = object.apellidos;
        this.entidad.identificacion = object.identificacion;
        this.entidad.tipo = btoa(object.tipo);
      } else {
        object = [];
        this.entidad._id = 0;
        this.entidad.p_uuid = "";
        this.entidad.nombres = "";
        this.entidad.apellidos = "";
        this.entidad.identificacion = "";
        this.entidad.tipo = "";
        this.entidad.telefono = [];
        this.entidad.direccion = [];
        this.entidad.correo = [];
        this.entidad.telefono.descripcion = "";
        this.entidad.direccion.descripcion = "";
        this.entidad.correo.descripcion = "";

        this.ociudad = "";
        this.oprovincia = "";
        this.opais = "";
        this.codigo_postal = "";
        this.tipo_responsabilidad = "";
      }

      this.entidad.persona = {};

      if (object.contactos != null) {
        for (var i in object.contactos) {
          if (object.contactos[i].tipo == "TELEFONO") {
            this.entidad.telefono = object.contactos[i];
          }

          if (object.contactos[i].tipo == "DIRECCION") {
            this.entidad.direccion = object.contactos[i];
          }

          if (object.contactos[i].tipo == "CORREO") {
            this.entidad.correo = object.contactos[i];
          }
        }
      } else {
        this.entidad.telefono = [];
        this.entidad.telefono.descripcion = "";
        this.entidad.correo = [];
        this.entidad.correo.descripcion = "";
        this.entidad.direccion = [];
        this.entidad.direccion.descripcion = "";
      }

      try {
        this.pais = [];
        this.provincia = [];
        this.ciudad = [];

        if (object.atributos != null) {
          if (object.atributos.pais != null) {
            this.pais.id = object.atributos.pais.codigo;
            this.pais.text = object.atributos.pais.descripcion;
            this.opais = object.atributos.pais.codigo + "";
            this.getProvincias(object.atributos.pais.codigo);
            this.oprovincia = object.atributos.provincia.codigo + "";
          } else {
            this.pais.id = "";
            this.pais.text = "";
          }

          if (object.atributos.provincia != null) {
            this.provincia.id = object.atributos.provincia.codigo;
            this.provincia.text = object.atributos.provincia.descripcion;
          } else {
            this.provincia.id = "";
            this.provincia.text = "";
          }

          if (object.atributos.provincia != null) {
            this.ciudad.id = object.atributos.ciudad.codigo;
            this.ciudad.text = object.atributos.ciudad.descripcion;
            this.getCiudades(
              object.atributos.pais.codigo,
              object.atributos.provincia.codigo
            );
            this.ociudad = object.atributos.ciudad.codigo + "";
          } else {
            this.ciudad.id = "";
            this.ciudad.text = "";
          }
        }
      } catch (error) {
        console.log(error);
      }

      try {
        this.responsable_iva = object.atributos.fiscales.responsable_iva
          ? "S"
          : "N";
      } catch (error) { }

      try {
        this.tipo_responsabilidad =
          object.atributos.fiscales.tipo_responsabilidad;
      } catch (error) { }

      try {
        this.codigo_postal = object.atributos.fiscales.codigo_postal;
      } catch (error) { }

      try {
        this.tipo_metodo_pago = object.atributos.fiscales.metodo_pago;
      } catch (error) { }

      try {
        this.tipo_uso_cfdi = object.atributos.fiscales.uso_cfdi;
      } catch (error) { }

      try {
        this.tipo_forma_pago = object.atributos.fiscales.forma_pago;
      } catch (error) { }

      $("#myModal").modal("show");
    },

    guardarClientes() {
      this.normalizeEntidadNombres();

      let fecha = new Date();

      var tercero = {};
      tercero._id = this.entidad._id == "" ? 0 : this.entidad._id;
      tercero.empresa_id = this.person.empresas;

      tercero.persona = {};
      tercero.persona._id =
        this.entidad.p_uuid == null ? 0 : this.entidad.p_uuid;
      tercero.persona.tipo_id = atob(this.entidad.tipo);
      tercero.persona.identificacion = this.entidad.identificacion;

      tercero.persona.nombres = this.entidad.nombres;
      tercero.persona.apellidos = this.entidad.apellidos;
      tercero.persona.fecha_nacimiento = fecha.toISOString().split("T")[0];
      tercero.persona.usuario_creacion = 0;
      tercero.persona.fecha_creacion = fecha.toISOString().split("T")[0];
      tercero.persona.url_foto = "";
      tercero.persona.estado = "A";
      tercero.persona.empresa_id = this.person.empresas;

      var telefono = {
        tipo: "TELEFONO",
        etiqueta: "PRINCIPAL",
        descripcion: this.entidad.telefono.descripcion,
        estado: "A",
      };
      var direccion = {
        tipo: "DIRECCION",
        etiqueta: "PRINCIPAL",
        descripcion: this.entidad.direccion.descripcion,
        estado: "A",
      };
      var correo = {
        tipo: "CORREO",
        etiqueta: "PRINCIPAL",
        descripcion: this.entidad.correo.descripcion,
        estado: "A",
      };

      tercero.persona.contacto = [];
      tercero.persona.contacto.push(telefono);
      tercero.persona.contacto.push(direccion);
      tercero.persona.contacto.push(correo);

      tercero.usuario = this.entidad.identificacion;
      tercero.estado = "A";
      tercero.periodo = 0;
      tercero.vencimiento = 0;
      tercero.cupo = 0;
      tercero.credito = 0;
      tercero.consumo_dinero = 0;
      tercero.consumo_volumen = 0;
      tercero.documento_id = 24;
      tercero.tercero_tipo = 1;

      tercero.atributos = this.entidad.atributos;

      if (tercero.atributos == null) {
        tercero.atributos = {};
      }

      //tercero.atributos.codigo_postal = this.codigo_postal

      tercero.atributos.pais = {};
      tercero.atributos.pais.codigo = this.pais.id;
      tercero.atributos.pais.descripcion = this.pais.text;

      tercero.atributos.provincia = {};
      tercero.atributos.provincia.codigo = this.provincia.id;
      tercero.atributos.provincia.descripcion = this.provincia.text;

      tercero.atributos.ciudad = {};
      tercero.atributos.ciudad.codigo = this.ciudad.id;
      tercero.atributos.ciudad.descripcion = this.ciudad.text;
      tercero.estado = "A";

      tercero.atributos.fiscales = {};
      tercero.atributos.fiscales.responsable_iva =
        this.responsable_iva == "SI" ? true : false;
      tercero.atributos.fiscales.tipo_responsabilidad =
        this.tipo_responsabilidad;
      tercero.atributos.fiscales.codigo_postal = this.codigo_postal;

      tercero.atributos.fiscales.metodo_pago = this.tipo_metodo_pago;
      tercero.atributos.fiscales.uso_cfdi = this.tipo_uso_cfdi;
      tercero.atributos.fiscales.forma_pago = this.tipo_forma_pago;

      var request = {};
      request.tercero = tercero;

      console.log(request);

      //crea o actualiza cliente
      this.reporteService
        .actualizarInformacionCliente(this.person, request)
        .then((data) => {
          $("#myModal").modal("hide");
          this.getReporteClientes();
        });
    },

    getReporteClientes() {
      this.reporte = [];
      this.loading = true;
      this.reporteService
        .getReporteClientes(this.person)
        .then((data) => {
          var x = 0;
          for (const i in data) {
            this.reporte[x] = [];
            this.reporte[x].item = x;
            this.reporte[x]._id = data[i]._id;
            this.reporte[x].p_uuid = data[i].p_uuid;
            this.reporte[x].documento = data[i].documento;
            this.reporte[x].identificacion = data[i].identificacion;
            this.reporte[x].nombres = data[i].nombres;
            this.reporte[x].apellidos = data[i].apellidos;
            this.reporte[x].tipo = data[i].tipo;
            this.reporte[x].atributos = data[i].atributos;
            this.reporte[x].contactos = data[i].contactos;
            x++;
          }
        })
        .then(() => {
          //FIX: en este orden soluciona el problema de datatable repetida//
          try {
            $("#table1").DataTable().destroy();
          } catch (error) { }
          $("#containter-table").html(this.table);
          const boxes = document.querySelectorAll(".btt");
          boxes.forEach((box) => {
            box.remove();
          });
          //ENDFIX: en este orden soluciona el problema de datatable repetida//

          $("#table1").DataTable({
            data: this.reporte,
            columns: [
              { data: "documento" },
              { data: "identificacion" },
              { data: "nombres" },
              { data: "apellidos" },
              {
                data: null,
                sortable: false,
                render: function (data, type, full, meta) {
                  var buttonID = full.item;
                  return (
                    '<button class="btn btn-sm btn-info" data-id="' +
                    buttonID +
                    '" id="detalles-clientes"><i class="fa-solid fa-receipt"></i></button>'
                  );
                },
              },
            ],
            dom:
              "<'btt row'<'col-sm-2'l><'col-sm-4'B><'col-sm-6'f>>" +
              "<'row'<'col-sm-12'tr>>" +
              "<'btt row'<'col-sm-5'i><'col-sm-7'p>>",
            buttons: [
              {
                extend: "copyHtml5",
                text: '<i class="fa-regular fa-clipboard"></i>',
              },
              {
                extend: "excelHtml5",
                text: '<i class="fa-regular fa-file-excel"></i>',
              },
              {
                extend: "csvHtml5",
                text: '<i class="fa-solid fa-file-csv"></i>',
              },
              {
                extend: "pdfHtml5",
                text: '<i class="fa-regular fa-file-pdf"></i>',
              },
            ],
            responsive: true,
            autoWidth: false,
            lengthMenu: [
              [10, 20, 50, -1],
              [10, 20, 50, "Todos"],
            ],
            language: {
              url: "plugins/Spanish.json",
            },
          });
          this.loading = false;

          var vm = this;
          $("#table1 tbody").off("click");
          $("#table1 tbody").on("click", "#detalles-clientes", vm, function () {
            let id = $(this).data("id");
            vm.getDetallesClientes(id);
          });

          $("#nuevo-clientes").on("click", vm, function () {
            let id = $(this).data("id");
            vm.getDetallesClientes(id);
          });
        });
    },

    findInArray(value, array) {
      var result = null;
      for (var i in array) {
        if (array[i].codigo == value) {
          result = array[i];
          break;
        }
      }
      return result;
    },

    getDocumentos() {
      if (this.documentos.length == 0) {
        this.documentos = [];
        this.reporteService.getListaTipoDocumento(this.person).then((data) => {
          let json = data;
          this.documentos = json.parametros.codigo_dian;
        });
      }
    },

    getResponsabilidades() {
      if (this.documentos.length == 0) {
        if (GLOBAL.COUNTRY == "CO") {
          this.lista_responsabilidad = [];
          this.lista_responsabilidad.push({
            _id: 7,
            descripcion: "GRAN CONTRIBUYENTE",
          });
          this.lista_responsabilidad.push({
            _id: 9,
            descripcion: "AUTORETENEDOR",
          });
          this.lista_responsabilidad.push({
            _id: 14,
            descripcion: "AGENTE RETENEDOR",
          });
          this.lista_responsabilidad.push({
            _id: 112,
            descripcion: "REGIMEN SIMPLE",
          });
          this.lista_responsabilidad.push({
            _id: 117,
            descripcion: "NO RESPONSABLE",
          });
          this.lista_responsabilidad.push({
            _id: 118,
            descripcion: "NO APLICA",
          });
        } else {
          this.lista_responsabilidad = [];
          this.reporteService
            .getListaTipoDocumentoMexico(this.person)
            .then((data) => {
              for (var i in data) {
                if (data[i].tipo == GLOBAL.CATALOGO_MEXICO.REGIMEN_FISCAL) {
                  data[i].descripcion =
                    data[i].codigo + " - " + data[i].descripcion;
                  this.lista_responsabilidad.push(data[i]);
                }

                if (data[i].tipo == GLOBAL.CATALOGO_MEXICO.METODO_PAGO) {
                  data[i].descripcion =
                    data[i].codigo + " - " + data[i].descripcion;
                  this.lista_metodo_pago.push(data[i]);
                }

                if (data[i].tipo == GLOBAL.CATALOGO_MEXICO.USO_CFDI) {
                  data[i].descripcion =
                    data[i].codigo + " - " + data[i].descripcion;
                  this.lista_uso_cfdi.push(data[i]);
                }

                if (data[i].tipo == GLOBAL.CATALOGO_MEXICO.FORMA_PAGO) {
                  data[i].descripcion =
                    data[i].codigo + " - " + data[i].descripcion;
                  this.lista_forma_pago.push(data[i]);
                }
              }
            });
        }
      }
    },

    getPaises() {
      if (this.paises.length == 0) {
        this.reporteService.getListaPaises(this.person).then((data) => {
          var json = data.parametro.paises;
          this.paises = [];
          for (var i in json) {
            this.paises.push({ id: json[i].codigo, text: json[i].name });
          }
        });
      }
    },

    selectPais({ id, text }) {
      console.log("Se ha ingresado al selectPais");

      for (var i in this.paises) {
        if (id == this.paises[i].id) {
          this.pais = this.paises[i];
          break;
        }
      }
      this.getProvincias(id);
      this.oprovincia = "";
      this.ociudad = "";
    },

    getProvincias(pais) {
      if (GLOBAL.COUNTRY == "CO") {
        this.reporteService
          .getListaProvincias(this.person, pais)
          .then((data) => {
            this.provincias = data;
          });
      } else {
        this.reporteService
          .getListaProvinciasFull(this.person, pais)
          .then((data) => {
            this.provincias = [];
            var valores = data.parametro.provincias;
            for (var i in valores) {
              this.provincias.push({
                id: valores[i].state_code,
                text: valores[i].name,
                country_code: valores[i].country_code,
                state_code: valores[i].state_code,
              });
            }
          });
      }
    },

    selectProvicias({ id, text }) {
      console.log(this.provincias);

      for (var i in this.provincias) {
        if (id == this.provincias[i].id) {
          this.provincia = this.provincias[i];
          break;
        }
      }

      if (GLOBAL.COUNTRY != "CO") {
        this.getCiudades(
          this.provincia.country_code,
          this.provincia.state_code
        );
      }
      this.ociudad = "";
    },

    getCiudades(pais, provincia) {
      if (GLOBAL.COUNTRY == "CO") {
        this.reporteService
          .getListaCiudades(this.person, pais, provincia)
          .then((data) => {
            this.ciudades = data;
          });
      } else {
        this.reporteService
          .getListaCiudadesFull(this.person, pais, provincia)
          .then((data) => {
            this.ciudades = data;
          });
      }
    },

    selectCiudad({ id, text }) {
      for (var i in this.ciudades) {
        if (id == this.ciudades[i].id) {
          this.ciudad = this.ciudades[i];
          break;
        }
      }
    },

    normalizeSpaces(value) {
      // null/undefined -> ""
      const s = (value ?? "").toString();
      // trim + colapsar cualquier bloque de espacios/tabulaciones a 1 espacio
      return s.trim().replace(/\s+/g, " ");
    },

    normalizeEntidadNombres() {
      // CO: nombres y apellidos; MX: solo nombres/razón social
      this.entidad.nombres = this.normalizeSpaces(this.entidad.nombres);

      if (this.GLOBAL.COUNTRY === "CO") {
        this.entidad.apellidos = this.normalizeSpaces(this.entidad.apellidos);
      }

      // opcional: también la identificación si quieres
      this.entidad.identificacion = this.normalizeSpaces(this.entidad.identificacion);

    },
  },
};
</script>
